<template>
  <page-view :menu="menu">
    <template #header>
      <base-header :title="$t('message.settings')" />
    </template>
    <template #content>
      <v-dialog
        v-if="selectedTransaction"
        v-model="dialog"
        persistent
        max-width="568px"
      >
        <v-card v-if="loadingDetails" class="py-5 px-4 detail-modal">
          <div class="d-flex justify-space-between">
            <span class="pageTitle" style="color: var(--v-newTitle-base)">
              {{ $t('message.pages.credits.details') }}</span
            >
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="mt-10">
            <loading-logo :value="200" />
          </div>
        </v-card>

        <v-card v-else class="py-5 px-4 detail-modal">
          <div class="d-flex justify-space-between">
            <span class="pageTitle" style="color: var(--v-newTitle-base)">
              {{ $t('message.pages.credits.details') }}</span
            >
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="d-flex justify-center align-center mb-1">
            <div
              v-if="selectedTransaction.status !== 'REFUNDED'"
              class="d-flex align-center"
            >
              <v-card
                flat
                v-if="
                  (selectedTransaction.type === 'SUB' &&
                    selectedTransaction.status !== 'REFUNDED') ||
                  selectedTransaction.status === 'FAILED'
                "
              >
                <img
                  src="../../../assets/credit_red_icon.svg"
                  class="large-icon"
                />
              </v-card>

              <v-card v-else width="24" height="24" flat>
                <v-img src="../../../assets/credit_small_icon.svg" />
              </v-card>

              <span
                v-if="
                  (selectedTransaction.type === 'SUB' &&
                    selectedTransaction.status !== 'REFUNDED') ||
                  selectedTransaction.status === 'FAILED'
                "
                style="font-size: 20px; color: #b71c1c"
              >
                - {{ selectedTransaction.amount }}</span
              >
              <span v-else style="font-size: 20px">
                {{ selectedTransaction.amount }}</span
              >
            </div>

            <div
              v-if="selectedTransaction.status == 'REFUNDED'"
              class="d-flex align-center strike-through"
            >
              <v-card width="24" height="24" flat>
                <v-img src="../../../assets/credit_small_icon.svg" />
              </v-card>
              <span style="font-size: 20px">{{
                selectedTransaction.amount
              }}</span>
            </div>
          </div>
          <div class="d-flex justify-center mb-1">
            <span v-if="paymentMethod === 'boleto' || paymentMethod === 'pix'">
              {{ $t('message.pages.credits.unkwounTransactionText') }}
            </span>
            <span v-else> {{ selectedTransaction.fullDescription }} </span>
          </div>

          <span
            class="tableItemText d-flex mb-10"
            style="justify-content: center"
          >
            <v-card
              v-if="selectedTransaction.status === 'PENDING'"
              color="#E6E8F8"
              class="statusText rounded-pill px-2 py-0"
              flat
            >
              <span class="text--center" :style="'color: #585D83'">
                {{ $t('message.pages.credits.processing').toUpperCase() }}
              </span>
            </v-card>
            <v-card
              v-else-if="selectedTransaction.status === 'FAILED'"
              color="#ffcdd2"
              class="statusText rounded-pill px-2 py-0"
              flat
            >
              <span class="text--center" :style="'color: #B71C1C'">
                {{ $t('message.pages.credits.failed').toUpperCase() }}
              </span>
            </v-card>
            <v-card
              v-else-if="selectedTransaction.status === 'REFUNDED'"
              color="#FFECB3"
              style="padding: 0px 6px 0px 6px; border-radius: 24px"
              flat
            >
              <span
                class="text--center"
                style="
                  font-size: 12px;
                  font-weight: 500;
                  text-transform: uppercase;
                "
                :style="'color:  #FF8F00'"
              >
                {{ $t('message.pages.userPlan.refunded') }}
              </span>
            </v-card>
            <v-card
              v-else-if="selectedTransaction.type === 'SUB'"
              color="#FFCDD2"
              class="statusText rounded-pill px-2 py-0 mt-1"
              flat
            >
              <span class="text--center" :style="'color: #B71C1C'">
                {{
                  selectedTransaction.status === 'FAILED'
                    ? $t('message.pages.credits.failed').toUpperCase()
                    : $t('message.pages.credits.debt').toUpperCase()
                }}
              </span>
            </v-card>
            <v-card
              v-else-if="selectedTransaction.status === 'COMPLETED'"
              width="17%"
              color="#C8E6C9"
              class="statusText rounded-pill px-2 py-0 mt-1"
              flat
            >
              <span class="text--center" :style="'color: #1B5E20'">
                {{ $t('message.pages.credits.added').toUpperCase() }}
              </span>
            </v-card>
          </span>

          <div
            v-if="
              selectedTransaction.type === 'ADD' ||
              selectedTransaction.status === 'REFUNDED'
            "
            class="px-14"
          >
            <div
              class="d-flex justify-space-between"
              style="border-bottom: 1px solid #e6e8f8"
            >
              <span> {{ $t('message.pages.credits.requestedIn') }}</span>
              <span class="mb-3">
                {{ formatedDate(selectedTransaction.created_at) }}</span
              >
            </div>
            <div
              class="d-flex justify-space-between mt-3"
              style="border-bottom: 1px solid #e6e8f8"
            >
              <span> {{ $t('message.pages.credits.creditedIn') }}</span>
              <span class="mb-3">
                {{ formatedDate(selectedTransaction.created_at) }}</span
              >
            </div>

            <div
              class="d-flex justify-space-between mt-3"
              style="border-bottom: 1px solid #e6e8f8"
            >
              <span> {{ $t('message.pages.credits.value') }}</span>
              <span class="d-flex mb-3">
                <span class="mr-2">
                  R$ {{ selectedTransaction.amount }},00
                </span>
                <v-img
                  v-if="selectedTransaction.has_nfe"
                  src="@/assets/nfeEnabled.svg"
                  max-width="24"
                  style="cursor: pointer"
                  @click="
                    downloadNfe(selectedTransaction.external_transaction_id)
                  "
                ></v-img>
              </span>
            </div>

            <div v-if="defaultSource" class="d-flex justify-space-between mt-3">
              <span> {{ $t('message.pages.credits.paymentMethod') }}</span>
              <span v-if="paymentMethod === 'pix'"> PIX </span>
              <span class="d-flex" v-if="paymentMethod === 'boleto'">
                <v-card
                  style="padding-left: 2px"
                  outlined
                  width="35"
                  height="24"
                  class="mr-2 rounded card-image d-flex align-center justify-center"
                >
                  <v-img src="@/assets/boletoIcon.svg" max-width="24" />
                </v-card>
                {{ $t('message.pages.userPlan.ticket') }}</span
              >
              <span v-if="paymentMethod === 'credit' && defaultSource">
                <v-row no-gutters v-if="defaultSource.type === 'card'">
                  <v-card
                    width="100%"
                    flat
                    class="d-flex flex-row align-center justify-space-between"
                  >
                    <v-row no-gutters>
                      <img
                        :src="
                          cardsImages[`${defaultSource.brand.toLowerCase()}`]
                        "
                        width="38"
                        class="rounded card-image"
                      />
                      <span
                        class="cardText textType2--text pl-2"
                        style="padding-top: 2px"
                      >
                        {{ capitalizeFirstLetter(defaultSource.brand) }}-{{
                          defaultSource.last4
                        }}
                      </span>
                    </v-row>
                  </v-card>
                </v-row>
              </span>
            </div>
          </div>

          <div v-else class="px-14">
            <div
              class="d-flex justify-space-between"
              style="border-bottom: 1px solid #e6e8f8"
            >
              <span> {{ $t('message.pages.credits.debitedIn') }}</span>
              <span class="mb-3">
                {{ formatedDate(selectedTransaction.created_at) }}</span
              >
            </div>

            <div class="d-flex justify-space-between mt-3">
              <span> {{ $t('message.pages.credits.usedIn') }}</span>
              <div style="max-width: 235px; text-align: right">
                <span> {{ selectedTransaction.fullDescription }} </span>
                <span
                  v-if="
                    selectedTransaction.video &&
                    selectedTransaction.video.title &&
                    selectedTransaction.description
                  "
                  class="text-truncate tableItemText primary--text"
                  style="max-width: 200px"
                  @click="goToVideoPage(selectedTransaction.video)"
                  :style="{
                    cursor: selectedTransaction.video ? 'pointer' : 'normal',
                  }"
                >
                  {{
                    selectedTransaction.description &&
                    selectedTransaction.fullDescription
                      ? selectedTransaction.video.title
                      : ''
                  }}
                </span>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <v-row no-gutters v-if="!hasFetchCredits">
        <loading-logo :value="200" />
      </v-row>
      <v-row no-gutters v-else>
        <v-col height="40" cols="12">
          <v-row no-gutters justify="space-between">
            <div class="d-flex align-center">
              <span
                style="align-items: center; display: flex"
                class="mr-2 pageTitle newTitle--text"
                >{{ $t('message.pages.credits.title') }}</span
              >
              <LearnMoreBtn
                :customTooltipMessage="
                  $t(
                    'message.pages.credits.creditsDrawerInfo.tooltipMessages.aiCredits'
                  )
                "
                :onClickBtn="() => handleGoToCreditsArticle()"
                customTooltipMessageStyle="max-width: 300px;"
                customClass="ask__btn--medium"
              />
            </div>
          </v-row>
          <v-divider
            style="min-width: 120%"
            class="full-width-divider"
          ></v-divider>
          <v-container class="pa-0">
            <v-row>
              <v-col cols="3">
                <v-card
                  flat
                  class="border-settings"
                  height="150px"
                  min-width="180px"
                >
                  <span
                    style="align-items: center; display: flex"
                    class="pageTitle newTitle--text pl-4 pt-4 pb-2"
                    >{{ $t('message.ai.spendCard.amount') }}</span
                  >
                  <div class="d-flex flex-column">
                    <v-card
                      height="40"
                      class="d-flex flex-row align-center justify-start pl-3"
                      flat
                    >
                      <v-card width="24" height="24" flat>
                        <v-img src="../../../assets/credit_small_icon.svg" />
                      </v-card>
                      <span v-if="!isBalanceLoading" class="pl-1">
                        {{
                          accountBalance.toLocaleString({
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </span>
                      <v-skeleton-loader
                        v-else
                        height="28"
                        width="30"
                        type="image"
                      ></v-skeleton-loader>
                    </v-card>
                  </div>
                  <v-card-actions class="pl-4 pb-4">
                    <v-btn
                      no-gutters
                      height="40"
                      width="150"
                      color="primary"
                      @click="handleAddCreditsModal"
                      >{{ $t('message.pages.credits.addCredits') }}</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="9">
                <v-card flat class="border-settings" height="150px">
                  <v-col
                    cols="12"
                    :class="isMobileBreakpoint ? 'mt-2 caption' : 'py-4 px-4'"
                  >
                    <v-skeleton-loader
                      v-if="isLoading"
                      class="my-0 pa-0"
                      type="list-item,list-item-three-line"
                    ></v-skeleton-loader>
                    <v-row v-else no-gutters>
                      <v-col
                        cols="12"
                        class="d-flex flex-row justify-space-between"
                      >
                        <v-row no-gutters>
                          <v-col
                            :cols="isMobileBreakpoint ? '12' : '6'"
                            class="d-flex justify-start"
                          >
                            <span style="line-height: 0">
                              <span
                                :class="{
                                  blackSubtitle: !$vuetify.theme.dark,
                                }"
                                class="pageTitle newTitle--text pt-4 pb-2"
                                style="line-height: 130%"
                                >{{
                                  $t(
                                    'message.pages.credits.creditsAutoRecharge'
                                  )
                                }}
                              </span>
                              <span class="ml-2">
                                <span
                                  class="mb-0 newItemText font-weight-medium"
                                  >{{ $t('message.pages.video.new') }}</span
                                >
                              </span>
                              <br />
                              <v-row no-gutters class="py-4">
                                <v-col class="d-flex align-start">
                                  <v-switch
                                    v-model="isAutoRechargeEnabled"
                                    class="my-0 py-0 align-start"
                                    compact
                                    hide-details
                                    @change="toggleAutoRecharge"
                                  ></v-switch>
                                  <div class="ml-2 d-flex flex-column">
                                    <span
                                      class="text-body-1 textType--text mb-2"
                                      style="
                                        white-space: nowrap;
                                        color: #3f404c;
                                      "
                                      >{{
                                        $t(
                                          'message.pages.credits.EnableCreditsAutoRecharge'
                                        )
                                      }}</span
                                    >
                                    <span>
                                      <small
                                        style="
                                          white-space: nowrap;
                                          color: #636578;
                                        "
                                        >{{
                                          $t(
                                            'message.pages.credits.creditsAutoRechargeDescription'
                                          )
                                        }}</small
                                      >
                                    </span>
                                  </div>
                                </v-col>
                              </v-row>
                            </span>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col
                            :cols="isMobileBreakpoint ? '12' : '4'"
                            class="d-flex align-center"
                          >
                            <v-row
                              no-gutters
                              justify="end"
                              align="center"
                              class="pt-4"
                            >
                              <BaseBtn @click="showAutoRechargeModal">{{
                                $t(
                                  'message.pages.credits.autoRechargeConfigBtn'
                                )
                              }}</BaseBtn>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-divider
            style="min-width: 120%"
            class="full-width-divider"
          ></v-divider>
        </v-col>
        <v-col>
          <div class="month__container">
            <v-icon class="icon-left" @click="previousMonth"
              >mdi-chevron-left</v-icon
            >
            <v-menu offset-y nudge-left="60.5">
              <template v-slot:activator="{ on, attrs }">
                <span class="month-option" v-bind="attrs" v-on="on">{{
                  getMonthName()
                }}</span>
              </template>
              <v-card
                style="padding: 15px 16px 15px 16px"
                class="popover-month"
              >
                <v-card-title
                  style="
                    padding: 0;
                    align-items: center;
                    display: flex;
                    justify-content: center;
                  "
                >
                  <v-icon style="font-size: 16px" @click="previousYear"
                    >mdi-chevron-left</v-icon
                  >
                  <span style="font-size: 14px; font-weight: 400">{{
                    selectedYear
                  }}</span>
                  <v-icon style="font-size: 16px" @click="nextYear"
                    >mdi-chevron-right</v-icon
                  >
                </v-card-title>
                <v-card-text style="padding: 0">
                  <v-container>
                    <v-row>
                      <v-col
                        cols="4"
                        style="padding: 0; text-align: center"
                        v-for="(month, index) in months"
                        :key="index"
                      >
                        <v-btn
                          style="padding: 0; text-align: center"
                          text
                          @click="selectMonth(index + 1)"
                        >
                          <span
                            :class="{
                              'selected-month': selectedMonth === index + 1,
                            }"
                            style="text-align: center; font-weight: 400"
                          >
                            {{ month }}
                          </span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-menu>
            <v-icon class="icon-right" @click="nextMonth"
              >mdi-chevron-right</v-icon
            >
          </div>
        </v-col>

        <template v-if="!creditsList.length && !loadingCredits">
          <v-container
            fill-height
            class="ma-0 pt-0 empty__container"
            style="width: 100%"
          >
            <v-row
              class="d-flex flex-column"
              no-gutters
              justify="center"
              align="center"
            >
              <img
                v-if="$vuetify.theme.dark"
                class="ml-4"
                src="@/assets/pandaLogo.svg"
                max-width="180"
              />
              <img
                v-else
                class="ml-4 mt-10"
                src="@/assets/pandaHappy.svg"
                max-width="180"
              />
              <span
                class="noFilesAddedText"
                v-html="$t('message.pages.credits.emptyTable')"
              ></span>
              <a class="mt-5" href="#" @click="handleGoToCreditsArticle">
                {{ $t('message.pages.credits.knowMore') }} &raquo;
              </a>
              <img
                class="svgArrowUp"
                src="@/assets/arrowUp.svg"
                style="align-self: flex-end"
              />
            </v-row>
          </v-container>
        </template>

        <v-col cols="12" class="mt-4">
          <v-row style="align-items: center" v-if="loadingCredits" no-gutters>
            <loading-logo style="align-items: center" :value="400" />
          </v-row>
          <v-row
            v-if="!loadingCredits"
            no-gutters
            class="container__credits-list"
          >
            <div class="d-flex">
              <v-col cols="12" class="mt-4">
                <v-row no-gutters class="container__credits-list">
                  <template v-for="day in orderedDays">
                    <div
                      class="d-flex justify-space-between align-center"
                      :key="'header-' + day"
                    >
                      <div
                        class="month-day"
                        style="
                          padding: 8px;
                          border-radius: 4px;
                          background-color: var(--v-neutral-lighten3);
                        "
                      >
                        <span
                          style="
                            font-weight: 500;
                            line-height: 21.6px;
                            font-size: 18px;
                          "
                          >{{ day }}</span
                        >
                      </div>

                      <span
                        class="d-flex align-center"
                        style="
                          font-size: 14px;
                          color: var(--v-neutral-lighten1);
                        "
                      >
                        <span style="margin-right: 8px">{{
                          $t('message.pages.credits.dayBalance')
                        }}</span>
                        <v-img
                          style="width: 16px; height: 16px; margin-right: 1px"
                          src="../../../assets/credit_small_icon.svg"
                        ></v-img>
                        <span class="day-balance">{{
                          calculateDailyBalance(groupedCreditsList[day])
                        }}</span>
                      </span>
                    </div>
                    <v-list :key="'list-' + day">
                      <template
                        v-for="(item, index) in groupedCreditsList[day]"
                      >
                        <v-list-item
                          class="itens-list"
                          :key="item.id"
                          style="padding: 0"
                          @click="openDialog(item)"
                        >
                          <v-list-item-content
                            v-if="
                              item.fullDescription === 'pix' ||
                              item.fullDescription === 'boleto'
                            "
                            >{{
                              $t('message.pages.credits.unkwounTransactionText')
                            }}
                          </v-list-item-content>
                          <v-list-item-content v-else
                            >{{ item.fullDescription }}
                          </v-list-item-content>

                          <div
                            style="width: 160px; justify-content: space-between"
                            class="d-flex"
                          >
                            <span class="tableItemText d-flex align-center">
                              <v-card
                                v-if="item.status === 'PENDING'"
                                color="#E6E8F8"
                                class="statusText rounded-pill px-2 py-0"
                                flat
                              >
                                <span
                                  class="text--center"
                                  :style="'color: #585D83'"
                                >
                                  {{
                                    $t(
                                      'message.pages.credits.processing'
                                    ).toUpperCase()
                                  }}
                                </span>
                              </v-card>
                              <v-card
                                v-else-if="item.status === 'FAILED'"
                                color="#ffcdd2"
                                class="statusText rounded-pill px-2 py-0"
                                flat
                              >
                                <span
                                  class="text--center"
                                  :style="'color: #B71C1C'"
                                >
                                  {{
                                    $t(
                                      'message.pages.credits.failed'
                                    ).toUpperCase()
                                  }}
                                </span>
                              </v-card>
                              <v-card
                                v-else-if="item.status === 'REFUNDED'"
                                color="#FFECB3"
                                style="
                                  padding: 0px 6px 0px 6px;
                                  border-radius: 24px;
                                "
                                flat
                              >
                                <span
                                  class="text--center"
                                  style="
                                    font-size: 12px;
                                    font-weight: 500;
                                    text-transform: uppercase;
                                  "
                                  :style="'color:  #FF8F00'"
                                >
                                  {{ $t('message.pages.userPlan.refunded') }}
                                </span>
                              </v-card>
                            </span>

                            <span
                              class="tableItemText pl-1 pr-2"
                              style="font-size: 16px; line-height: 24px"
                              :style="
                                item.type === 'SUB' || item.status === 'FAILED'
                                  ? 'color: #B71C1C'
                                  : item.status === 'PENDING'
                                  ? 'color: #585D83'
                                  : 'color: #1b5e20'
                              "
                            >
                              {{ item.type === 'SUB' ? '-' : '' }}
                              {{ item.amount }}
                            </span>
                          </div>
                        </v-list-item>
                        <v-divider
                          :key="'divider-' + item.id"
                          v-if="index !== groupedCreditsList[day].length - 1"
                        ></v-divider>
                      </template>
                      <v-divider class="pb-3"></v-divider>
                    </v-list>
                  </template>
                </v-row>
              </v-col>
            </div>
            <v-col cols="12" v-if="!creditsList.length">
              <v-divider class="divider-color"></v-divider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <AutoRechargeModal
        v-model="openAutoRechargeModal"
        :isAutoRechargeEnabled="isAutoRechargeEnabled"
      ></AutoRechargeModal>
    </template>
  </page-view>
</template>

<script>
// internal imports
import linkHelper from '@/utils/linkHelper.mixin.js'
import { mapState } from 'vuex'
import axios from 'axios'
import Storage from '@/utils/Storage'

// API
import creditsApi from '@/services/creditsApi'
import planApi from '@/services/planApi'
import invoiceApi from '@/services/invoiceApi'

// Components
import PageView from '@/layout/PageView.vue'
import LoadingLogo from '@/components/LoadingLogo.vue'
import LearnMoreBtn from '@/components/LearnMoreBtn.vue'
import i18n from '@/translations/lang'
import BaseBtn from '@/components/BaseBtn.vue'
import AutoRechargeModal from './CreditsAutoRechargeModal.vue'

export default {
  name: 'Credits',
  mixins: [linkHelper],
  components: {
    PageView,
    LoadingLogo,
    LearnMoreBtn,
    BaseHeader: () => import('@/components/BaseHeader.vue'),
    BaseBtn,
    AutoRechargeModal,
  },
  data() {
    return {
      hasFetchCredits: false,
      loadingDetails: false,
      creditsList: [],
      isBalanceLoading: false,
      loadingCredits: true,
      paymentMethods: '',
      groupedCreditsList: {},
      dialog: false,
      defaultSource: null,
      cardsImages: {
        mastercard:
          'https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg',
        visa: 'https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg',
        elo: 'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
        american_express:
          'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
      },
      selectedTransaction: null,
      accountBalance: 0,
      headers: [
        {
          prop: '_action',
          name: 'Data e hora',
          actionName: 'time',
          width: 140,
        },
        {
          prop: '_action',
          name: 'Descrição',
          actionName: 'description',
        },
        {
          prop: '_action',
          name: 'Créditos',
          actionName: 'credits',
          width: 104,
        },
        {
          prop: '_action',
          name: 'Situação',
          actionName: 'situation',
          width: 146,
        },
      ],
      userOrder: false,
      eventOrder: false,
      groupOrder: false,
      months: [],
      selectedMonth: new Date().getMonth() + 1,
      selectedYear: new Date().getFullYear(),
      dateOrder: false,
      loadings: {
        fetchData: false,
        fetchCreditsInfo: false,
      },
      creditLinks: {
        pt: 'https://help.pandavideo.com/pt-br/article/como-funcionam-os-creditos-da-panda-video-sl8v0f/',
        en: 'https://help.pandavideo.com/en-us/article/how-does-panda-video-credits-work-1w67k8n/',
      },
      openAutoRechargeModal: false,
      isAutoRechargeEnabled: null,
      isLoading: true,
      isBeta: false,
    }
  },
  computed: {
    ...mapState('user', {
      userInfo: (state) => state.userPlanInfo.user,
    }),
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    menu() {
      return this.$store.state.user.settingsNavItems
    },
    tableHeight() {
      if (this.creditsList.length < 5) {
        return 288
      } else if (this.creditsList.length <= 100) {
        return (this.creditsList.length + 1) * 48 + 5
      } else {
        return 4805
      }
    },
    orderedDays() {
      const days = Object.keys(this.groupedCreditsList)
      return days.sort((a, b) => b - a)
    },
    translatedMonths() {
      return [
        this.$t('message.pages.credits.january'),
        this.$t('message.pages.credits.february'),
        this.$t('message.pages.credits.march'),
        this.$t('message.pages.credits.april'),
        this.$t('message.pages.credits.may'),
        this.$t('message.pages.credits.june'),
        this.$t('message.pages.credits.july'),
        this.$t('message.pages.credits.august'),
        this.$t('message.pages.credits.september'),
        this.$t('message.pages.credits.october'),
        this.$t('message.pages.credits.november'),
        this.$t('message.pages.credits.december'),
      ]
    },
    paymentMethod() {
      let type = ''
      if (this.selectedTransaction && this.selectedTransaction.description) {
        let description = this.selectedTransaction.description.toLowerCase()
        if (description.includes('boleto')) {
          type = 'boleto'
        } else if (description.includes('pix')) {
          type = 'pix'
        } else if (description.includes('card')) {
          type = 'credit'
        } else type = 'credit'
      }
      return type
    },
  },
  async mounted() {
    this.isBeta = location.search.match('beta')
    this.getCards()
    await this.getCreditsInfo()
    this.$root.$on('updateCreditsList', async () => {
      try {
        this.isBalanceLoading = true
        await this.getCreditsInfo()
        this.getCreditsInfo()
      } finally {
        this.isBalanceLoading = false
        this.$root.$emit('reloadBalance')
      }
    })
    this.$root.$on('isAutoRechargeEnabled', (val) => {
      this.isAutoRechargeEnabled = val
    })
  },
  created() {
    this.months = [
      this.$t('message.pages.credits.january'),
      this.$t('message.pages.credits.february'),
      this.$t('message.pages.credits.march'),
      this.$t('message.pages.credits.april'),
      this.$t('message.pages.credits.may'),
      this.$t('message.pages.credits.june'),
      this.$t('message.pages.credits.july'),
      this.$t('message.pages.credits.august'),
      this.$t('message.pages.credits.september'),
      this.$t('message.pages.credits.october'),
      this.$t('message.pages.credits.november'),
      this.$t('message.pages.credits.december'),
    ]
  },
  watch: {},
  methods: {
    handleAddCreditsModal() {
      this.$root.$emit('creditsBuyModal')
    },
    calculateDailyBalance(transactions) {
      return transactions.reduce((acc, transaction) => {
        if (transaction.type === 'ADD') {
          return acc + transaction.amount
        } else if (
          transaction.type === 'SUB' &&
          transaction.status !== 'REFUNDED'
        ) {
          return acc - transaction.amount
        }
        return acc
      }, 0)
    },
    async getCards() {
      this.loadings.getCardsLoading = true
      try {
        const { data } = await planApi.getCards()
        this.userCards = data.sources.filter((source) => source.type === 'card')
        this.userCards.push({ id: 'newCard' })
        const card = data.sources.find((item) => item.default === true)
        if (card.type === 'card') {
          this.radioCardValue = card.id
        }
        this.defaultSource = card
        this.$root.$emit('paymentSourceType', card.type)
        this.loadings.getCardsLoading = false
      } catch (error) {
        this.loadings.getCardsLoading = false
      }
      this.getAutoRechargeSettings()
    },
    goToVideoPage(video) {
      if (!video) return
      let routeData = this.$router.resolve({
        name: 'VideoPage',
        params: { id: video.id },
      })
      window.open(routeData.href, '_blank')
    },
    async openDialog(transaction) {
      this.dialog = true
      this.loadingDetails = true
      if (transaction.type === 'ADD' || transaction.status === 'REFUNDED') {
        try {
          const data = await this.getCreditDetails(transaction.id)
          transaction.has_nfe = data.history.has_nfe
        } catch (error) {
          console.error(error)
        } finally {
          this.loadingDetails = false
        }
      } else {
        this.loadingDetails = false
      }
      this.selectedTransaction = transaction
    },
    previousMonth() {
      if (this.selectedMonth === 1) {
        this.selectedMonth = 12
        this.selectedYear -= 1
      } else {
        this.selectedMonth -= 1
      }
      this.getCreditsInfo()
    },
    nextMonth() {
      if (this.selectedMonth === 12) {
        this.selectedMonth = 1
        this.selectedYear += 1
      } else {
        this.selectedMonth += 1
      }
      this.getCreditsInfo()
    },
    previousYear() {
      event.stopPropagation()
      this.selectedYear -= 1
    },
    nextYear() {
      event.stopPropagation()
      this.selectedYear += 1
    },
    selectMonth(month) {
      this.selectedMonth = month
      this.getCreditsInfo()
    },

    getDescription(transaction) {
      if (transaction.status === 'FAILED')
        return `${i18n.t('message.pages.credits.failed')}`
      if (
        transaction.description &&
        ['boleto'].some((word) => transaction.description.includes(word))
      )
        return 'boleto'
      if (
        transaction.description &&
        ['pix'].some((word) => transaction.description.includes(word))
      )
        return 'pix'
      let desc = this.getSwitchDescription(transaction)
      if (transaction.status === 'REFUNDED')
        return `${i18n.t('message.pages.credits.refund')} ${desc}`
      return desc
    },
    groupCreditsByDay(creditsList) {
      const grouped = creditsList.reduce((acc, item) => {
        const day = new Date(item.created_at).getDate()
        if (!acc[day]) {
          acc[day] = []
        }
        acc[day].push(item)
        return acc
      }, {})

      this.groupedCreditsList = grouped
    },
    getSwitchDescription(transaction) {
      if (transaction.status !== 'REFUNDED') {
        switch (transaction.description) {
          case 'TRANSLATION':
            return `${i18n.t('message.pages.credits.translationText')} `
          case 'TRANSCRIPTION':
            return `${i18n.t('message.pages.credits.transcriptionText')} `
          case 'TEXT_ITEMS':
            return `${i18n.t('message.pages.credits.textItemsText')} `
          case 'DUBBING':
            return `${i18n.t('message.pages.credits.dubbingText')} `
          case 'COURTESY':
            return `${i18n.t('message.pages.credits.courtesyText')} `
          default:
            return `${i18n.t('message.pages.credits.unkwounTransactionText')} `
        }
      } else return ''
    },
    async getCreditsInfo() {
      this.loadings.fetchCreditsInfo = true
      this.loadingCredits = true
      try {
        const startDate = new Date(this.selectedYear, this.selectedMonth - 1, 1)
          .toISOString()
          .slice(0, 10)
        const endDate = new Date(this.selectedYear, this.selectedMonth, 0)
          .toISOString()
          .slice(0, 10)

        const { data } = await creditsApi.getCreditsHistory(startDate, endDate)
        const transactionsWithDescription = data.history
          .map((transaction) => {
            const description = this.getDescription(transaction)
            return {
              ...transaction,
              fullDescription: description,
            }
          })
          .filter((transaction) => {
            const transactionDate = new Date(transaction.created_at)
            return (
              transactionDate.getMonth() + 1 === this.selectedMonth &&
              transactionDate.getFullYear() === this.selectedYear
            )
          })

        this.creditsList = transactionsWithDescription
        this.accountBalance = data.balance
      } finally {
        this.loadings.fetchCreditsInfo = false
        this.loadingCredits = false
      }
      this.groupCreditsByDay(this.creditsList)
      this.hasFetchCredits = true
    },

    async getCreditDetails(credit_id) {
      const response = await creditsApi.getCreditDetails(credit_id)
      return response.data
    },
    formatedDate(dataISO) {
      let data = new Date(dataISO)
      data.setHours(data.getHours())
      let dia = data.getDate().toString().padStart(2, '0')
      let mes = (data.getMonth() + 1).toString().padStart(2, '0')
      let ano = data.getFullYear().toString()
      let horas = data.getHours().toString().padStart(2, '0')
      let minutos = data.getMinutes().toString().padStart(2, '0')

      return `${dia}/${mes}/${ano} - ${horas}h${minutos}`
    },

    async invoices() {
      let res = await invoiceApi.getInvoices()
      return res.data
    },

    async downloadNfe(invoiceId) {
      const res = await axios.get(
        `https://api-v2.pandavideo.com/stripe/invoices?payment_intent_id=${invoiceId}&download_nfe=1`,
        {
          headers: {
            Authorization: `Bearer ${Storage.getItem('accessToken')}`,
            Accept: 'application/pdf',
          },
          responseType: 'blob',
        }
      )
      window.open(
        URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
      )
    },

    handleKnowMore() {
      const link = this.getCreditsLink()
      window.open(link, '_blank')
    },
    getMonthName() {
      return this.months[this.selectedMonth - 1]
    },
    capitalizeFirstLetter(string) {
      if (!string) return
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    formatDate(timestamp) {
      const date = new Date(timestamp)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    },
    handleGoToCreditsArticle() {
      const articleLink =
        this.creditLinks[this.$i18next.resolvedLanguage] ??
        this.creditLinks['en']
      window.open(articleLink, '_blank')
    },
    toggleAutoRecharge(val) {
      if (val) {
        setTimeout(() => {
          this.isAutoRechargeEnabled = false
        }, 50)
        this.openAutoRechargeModal = true
      } else {
        this.deleteAutoRechargeSettings()
      }
    },
    showAutoRechargeModal() {
      this.openAutoRechargeModal = true
    },
    async getAutoRechargeSettings() {
      this.isLoading = true
      try {
        const { data } = await planApi.getCreditsAutoRechargeSettings()
        this.isAutoRechargeEnabled = true
        const settedAction = Number(data.action_value)
        const settedTrigger = Number(data.trigger_value)
        this.$root.$emit('updateSettingsValues', settedTrigger, settedAction)
        await this.handlePaymentType()
        this.isLoading = false
      } catch (error) {
        const {
          response: { status: statusCode },
        } = error
        if (statusCode == 404) {
          this.isAutoRechargeEnabled = false
          this.isLoading = false
        }
      }
    },
    async deleteAutoRechargeSettings() {
      try {
        await planApi.deleteCreditsAutoRechargeSettings()
        this.$root.$emit('autoRechargeDisabled')
        this.isAutoRechargeEnabled = false
      } catch (error) {
        console.error(error)
        this.isAutoRechargeEnabled = true
      }
    },
    async handlePaymentType() {
      const paymentType = this.defaultSource.type
      if (paymentType !== 'card') {
        await this.deleteAutoRechargeSettings()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pageTitle {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
}

.month__container {
  display: flex;
  justify-content: center;
}

.month-option {
  height: 40px;
  width: 173px;
  padding: 8px 50px 8px 50px;
  border: 1px solid var(--v-neutral-lighten2);
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: var(--v-neutral-base);
  text-align: center;
}

.strike-through {
  position: relative;
  display: flex;
  align-items: center;
}

.strike-through::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background-color: var(--v-neutral-lighten1);
  top: 50%;
}

.icon-left {
  width: 40px;
  height: 40px;
  border: 1px solid var(--v-neutral-lighten2);
  border-right: 0px;
  border-radius: 4px 0px 0px 4px;
}

.icon-right {
  width: 40px;
  height: 40px;
  border: 1px solid var(--v-neutral-lighten2);
  border-left: 0px;
  border-radius: 0px 4px 4px 0px;
}

.v-icon:focus::after {
  opacity: 0 !important;
}

.detail-modal {
  height: 411px;
}

.full-width-divider {
  margin-top: 24px;
  margin-bottom: 24px;
  margin-left: -24px !important;
  margin-right: -24px !important;
  width: calc(100% + 48px) !important;
}

.selected-month {
  color: var(--v-primary-base);
}

.v-btn {
  text-transform: none;
  letter-spacing: 0;
}

.large-icon {
  width: 24px;
  height: 24px;
}

.popover-month {
  max-width: 294px;
  max-height: 211px;
}

.text-truncate {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tableItemText {
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
}

.statusText {
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  /* 18px */
}

.container__credits-list {
  width: 100%;
  overflow: auto;

  > div {
    width: 100%;
    min-width: 452px;
  }
}
.border-settings.theme--light {
  border: 1px solid var(--v-neutral-lighten3) !important;
}
.border-settings.theme--dark {
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}
::v-deep .v-skeleton-loader .v-skeleton-loader__list-item-three-line {
  padding: 0 !important;
  margin-top: -18px;
}
::v-deep .v-skeleton-loader .v-skeleton-loader__list-item {
  padding: 0 !important;
}
</style>

<style lang="scss">
.creditsTable {
  overflow-x: hidden !important;
  background-color: var(--v-dark-newBackground);
  border: none !important;
}

.creditsTable .t-header {
  display: none;
}

.cardText {
  font-size: 14px;
  line-height: 150%;
  color: var(--v-neutral-base);
}

.bg-dark .creditsTable .item-line {
  background-color: var(--v-neutral-darken2) !important;
}

.creditsTable .header-cell {
  justify-content: start !important;
  padding-left: 20px !important;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
}

.itens-list:hover {
  background-color: #ebedff;
  cursor: pointer;
}

.divider-color {
  color: var(--v-contrast-base);
}

.creditsTable .item-cell {
  border-bottom: 0px !important;
  border-top: 1px solid var(--v-contrast-base);
  padding: 0px !important;
}

$size: 1.35rem;

.bg-dark {
  .month-option {
    color: var(--v-neutral-lighten4);
  }

  .itens-list:hover {
    background-color: #0f1118;
  }

  .month-day {
    color: var(--v-neutral-darken2);
  }

  .intro {
    &__btn {
      --intro-background-color: rgba(255, 255, 255, 0.54);
      --intro-foreground-color: #000;
    }
  }
}

.intro {
  &__btn {
    --intro-background-color: var(--v-neutral-lighten1);
    --intro-foreground-color: var(--v-neutral-lighten4);

    position: relative;
    top: 0.5px;

    &::v-deep {
      .v-icon {
        background-color: var(--intro-background-color);
        width: $size;
        height: $size;
        border-radius: 100%;

        &[class*='mdi-'] {
          font-size: $size * 0.8;

          &::before {
            color: var(--intro-foreground-color);
          }
        }
      }
    }
  }
}

.noFilesAddedText {
  max-width: 600px;
}
</style>
